import React from 'react';
import { Switch } from 'react-router-dom';
import SafetyRoute from 'components/kea/SafetyRoute';
import { Redirect } from 'react-router';
import OnboardingVisualSearch from 'containers/OnboardingVisualSearch';
import OnboardingVisualRecs from 'containers/OnboardingVisualRecs';

const VisualSearchRouter = ({ match }) => {
  const { url } = match;
  const dashboardUrl = `${url}/dashboard`;
  return (
    <Switch>
      <SafetyRoute
        path={`${url}/onboarding`}
        render={(props) => <OnboardingVisualSearch {...props} />}
      />
      <SafetyRoute component={() => <Redirect to={dashboardUrl} />} />
    </Switch>
  );
};

export default VisualSearchRouter;
